$shm_hitalama_map_widget_float_table_pick $mol_pick
	Follower $shm_hitalama_map_widget_float_table_follower
		offset <= bubble_offset
		align <= bubble_align
		Anchor <= Anchor
		Sub <= Bubble
